import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CheckboxUpdateService {

  checkboxUpdate$: Subject<void> = new Subject<void>()

  constructor() {
  }
}
